// extracted by mini-css-extract-plugin
export default {"header":"heading_header__2gEzh","heading":"heading_heading__cBINC","heading-hr":"heading_heading-hr__tv9ud"};